import { NetWorthPoint } from "@/lib/api/portfolio";

/**
 * Annualizes the current net return using the elapsed days since the first
 * invested point. Below one year of history, annualizing would exaggerate a
 * short window's return, so the raw current return is used instead.
 */
export function computeAnnualizedPerformance(history: NetWorthPoint[]): number {
  if (!history.length) return 0;

  const currentReturn = history[history.length - 1].portfolio_return_percent;
  const firstInvestedPoint = history.find((pt) => pt.portfolio_investment > 1e-5);
  if (!firstInvestedPoint) return currentReturn;

  const firstDate = new Date(firstInvestedPoint.date);
  const today = new Date();
  const daysHeld = Math.max(1, (today.getTime() - firstDate.getTime()) / (1000 * 60 * 60 * 24));

  if (daysHeld <= 365) return currentReturn;
  return (Math.pow(1 + currentReturn / 100, 365 / daysHeld) - 1) * 100;
}
